import React from 'react';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import i18n from 'i18n';
import { css } from 'styled-components';
import FontStyles from 'constants/font-styles';
import FormDialogrenderer from 'components/OrderAggregators/components/FormDialogRenderer';
import Button from 'components/common/Button';

const judgeAgreement = (value, handleChangeAgreement, close) => {
  handleChangeAgreement(value);
  close();
};

const DialogBody = ({ className }) => (
  <div className={className}>
    <ul className="licence-dialog">
      {i18n.t('terms:terms', { returnObjects: true }).map((item, i) => (
        <li key={i}>
          <div className="licence-header">{item.title}</div>
          <div className="licence-content">{item.detail}</div>
        </li>
      ))}
    </ul>
    <ul className="end-of-terms">
      <li>{i18n.t('terms:endOfTerms.publisher')}</li>
      <li>{i18n.t('terms:endOfTerms.contactHeader')}</li>
      <li>{i18n.t('terms:endOfTerms.contact')}</li>
      <li>{i18n.t('terms:endOfTerms.dateOfEnforcement')}</li>
      <li>{i18n.t('terms:endOfTerms.end')}</li>
    </ul>
  </div>
);

const DialogFooter = ({ close, handleChangeAgreement }) => (
  <div className="footer-btn-wrapper">
    <Button
      buttonType="D"
      type="button"
      onClick={() => judgeAgreement(false, handleChangeAgreement, close)}
    >
      {i18n.t('orderAggregators:confirmation:disagreeToLicenceDialog')}
    </Button>
    <Button
      buttonType="B"
      type="button"
      onClick={() => judgeAgreement(true, handleChangeAgreement, close)}
    >
      {i18n.t('orderAggregators:confirmation:agreeToLicenceDialog')}
    </Button>
  </div>
);

const LicenceDialog = ({ className, dialogRef, handleChangeAgreement }) => (
  <div className={className}>
    <FormDialogrenderer
      title={i18n.t('orderAggregators:confirmation:licence')}
      innerRef={dialogRef}
      renderBody={() => <DialogBody />}
      renderFooter={props => (
        <DialogFooter
          {...props}
          handleChangeAgreement={value => handleChangeAgreement(value)}
        />
      )}
      hideCloseButton={true}
    />
  </div>
);

const commonStyle = css`
  ${FontStyles.text8};

  ul {
    list-style: none;
    padding-left: 0;
  }

  .licence-header {
    ${FontStyles.text5};
  }

  .licence-content {
    white-space: pre-wrap;
  }

  .end-of-terms {
    text-align: right;
  }

  .footer-btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .licence-dialog {
    margin: 28px 32px;
  }

  .end-of-terms {
    padding: 0 32px;
  }

  .licence-header {
    margin-bottom: 7px
  }

  .licence-content {
    margin-bottom: 32px
  }

  .footer-btn-wrapper {
    ${Button} {
      &:first-child {
        margin-right: 16px;
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .licence-dialog {
    margin: 12px 16px;
  }

  .end-of-terms {
    padding: 0 16px;
    font-size: 12px;
  }

  .licence-header {
    margin-bottom: 5px
  }

  .licence-content {
    margin-bottom: 24px
  }
`;

export default applyStyles(LicenceDialog)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Confirmation/components/LicenceDialog.js